import { Record, Set } from 'immutable';
import { EventSearchFilter } from './event-filter';
import { EventSort } from './event-sort';

const EventSearchParametersRecord = Record({
  maxEvents: 0,
  searchText: Set([]),
  filters: Set([]),
  sorts: Set([]),
  filterDescriptions: Set([])
});

export class EventSearchParameters extends EventSearchParametersRecord {
  maxEvents: number;
  searchText: Set<string>;
  filters: Set<EventSearchFilter>;
  sorts: Set<EventSort>;
}

export class EventSearchParamsDesc extends EventSearchParameters {
  filterDescriptions: Set<string>;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/event-search-params.ts